export class PdpSearchCriteria {
	numeroPdp!: string;
	agence?: number;
	antenne?: number;
	groupement?: number;
	parc?: number;
	entreprise?: number;
	typePdp!: number[];
	etat!: number[];
	validite!: number[];
	monPerimetreReferent!: boolean;
	currentUserId?: number;
}